import React from 'react';
import { Toaster as SonnerToaster } from 'sonner';
import { alpha, useMediaQuery, useTheme } from '@mui/material';

import { ToasterErrorIcon, ToasterSuccessIcon, ToasterLoadingIcon, ToasterInfoIcon } from './icons';

export const Toaster = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <SonnerToaster
      richColors
      closeButton={!isMobile}
      toastOptions={{
        style: {
          ...theme.typography.body2,
        },
        actionButtonStyle: {
          ...theme.typography.body2,
          borderRadius: '5px',
          backgroundColor: alpha(theme.palette.background.paper, 0.5),
          color: 'inherit',
        },
      }}
      icons={{
        success: <ToasterSuccessIcon />,
        loading: <ToasterLoadingIcon />,
        error: <ToasterErrorIcon />,
        info: <ToasterInfoIcon />,
      }}
    />
  );
};
